<zimmerer-route-ion-wrapper class="ion-page">

  <div *ngIf="user" class="threecol" fxLayout="column" fxLayoutAlign.gt-md="center center">

    <div class="main-col withBottomPadding" [class.withTopPadding]="MobileService.isMobile"
      [class.noSlider]="!hasSliderImages" fxLayout="column" fxLayoutGap="20px">

      <image-slider [page]="'profile'" [fxHide]="!hasSliderImages" fxHide.lt-lg></image-slider>

      <div fxLayout="row" fxLayout.lt-lg="column">
        <!-- nav menu -->
        <div fxHide.lt-lg class="min-menu-wrapper" fxFlex="15">
          <app-profile-nav></app-profile-nav>
        </div>

        <div id="profileComponentContent" fxFlex="85" fxFlex.xs="100">

          <div class="about-cube">
            <app-profile-header [profile]="user"
              [editDisabled]="editNames || editPersonal || editSocial || editAddress"></app-profile-header>

            <div class="aboutme-content" fxLayout="column" fxLayoutGap="20px">

              <div>
                Das ist Dein persönliches Profil. Du kannst Dein persönliches Profil vervollständigen, damit andere
                Mitglieder dich besser kennenlernen. Welche Daten für andere Mitglieder sichtbar sind, entscheidest Du
                selbst in den Privatsphäreeinstellungen. Wenn Du dein Profil vervollständigst bekommst Du Woodcoins,
                welche
                Du im Bonus-Bereich ansehen kannst.
              </div>

              <div>
                So sieht dein Profil für andere aus:
              </div>

              <div>
                <button (click)="preview()" class="mobileGrowBtn">
                  <i class="fas fa-globe"></i>
                  Ansehen
                </button>
              </div>

              <!-- show info -->

              <!-- information blocks -->
              <form *ngIf="form" [formGroup]="form" fxLayout="column" fxLayoutGap="30px">

                <!-- NAMES -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [(edit)]="editNames" [title]="'Namen'" [checkbox]="true"
                    [baseDataObject]="user" [privacyUserAttributeName]="'use_nickname'"
                    [atts]="['firstname', 'lastname', 'private_nickname', 'use_nickname']" [save]="save.bind(this)"
                    [savedisabled]="form.invalid"
                    [editdisabled]="editPersonal||editSocial||editAddress||editCareer||editAboutme"
                    [cancel]="cancel.bind(this)" [disableNicknameOnly]="form.value.private_nickname?.length < 1"
                    [tooltip]="messages.texts.profile.blockheader.infotexts.names" [form]="form"
                    [(submitted)]="submitted">
                  </app-about-block-header>

                  <!-- firstname -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Vorname:</div>

                    <!-- edit -->
                    <div *ngIf="editNames" fxFlex="grow" fxLayout="column">
                      <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" type="text" matInput formControlName="firstname" />
                      </mat-form-field>

                      <mat-error *ngIf="form.get('firstname').errors && (submitted || form.get('firstname').touched)">
                        *Vorname muss zwischen zwei und fünfzig Zeichen lang sein
                      </mat-error>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editNames">
                      {{ user.firstname }}
                    </div>
                  </div>

                  <!-- lastname -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Nachname:</div>

                    <!-- edit -->
                    <div *ngIf="editNames" fxFlex="grow" fxLayout="column">
                      <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" type="text" matInput formControlName="lastname" />
                      </mat-form-field>

                      <mat-error *ngIf="form.get('lastname').errors && (submitted || form.get('lastname').touched)">
                        *Nachname muss zwischen zwei und fünfzig Zeichen lang sein
                      </mat-error>

                    </div>

                    <!-- show -->
                    <div *ngIf="!editNames">
                      {{ user.lastname }}
                    </div>
                  </div>

                  <!-- nickname -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Nickname:</div>

                    <!-- edit -->
                    <div *ngIf="editNames" fxFlex="grow" fxLayout="column">
                      <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" type="text" matInput formControlName="private_nickname"
                          (change)="disableShowNickname()" />
                      </mat-form-field>

                      <mat-error
                        *ngIf="form.get('private_nickname').errors && (submitted || form.get('private_nickname').touched)">
                        *Nickname muss zwischen zwei und fünfzig Zeichen lang sein
                      </mat-error>

                    </div>

                    <!-- show -->
                    <div *ngIf="!editNames">
                      {{ user.private_nickname }}
                    </div>
                  </div>
                </div>

                <!-- PERSONAL INFORMATION -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [(edit)]="editPersonal" [baseDataObject]="user"
                    [privacyUserAttributeName]="'private_personal_information_privacy'"
                    [title]="'Persönliche Informationen'" [atts]="['private_gender', 'private_date_of_birth']"
                    [save]="save.bind(this)" [savedisabled]="form.invalid"
                    [editdisabled]="editNames||editSocial||editAddress||editCareer||editAboutme"
                    [cancel]="cancel.bind(this)" [tooltip]="messages.texts.profile.blockheader.infotexts.personal"
                    [form]="form" [(submitted)]="submitted">
                  </app-about-block-header>

                  <!-- gender -->
                  <div fxLayout="row" fxLayout.lt-lg="column" class="genderSelect">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Geschlecht:</div>

                    <div *ngIf="editPersonal">
                      <mat-form-field>
                        <mat-select formControlName="private_gender">
                          <mat-option [value]="'FEMALE'">Weiblich</mat-option>
                          <mat-option [value]="'MAN'">Männlich</mat-option>
                          <mat-option [value]="'DIVERSE'">Divers</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div *ngIf="!editPersonal">
                      {{ user.private_gender | translate }}
                    </div>
                  </div>

                  <!-- birthday -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Geburtstag:</div>

                    <!-- edit -->
                    <div *ngIf="editPersonal">
                      <mat-form-field>

                        <input matInput type="text" formControlName="private_date_of_birth" placeholder="Datum wählen">

                        <!-- <input
                      matInput
                      [matDatepicker]="picker"
                      (focus)="picker.open()"
                      placeholder="Datum wählen"
                      formControlName="private_date_of_birth"
                      [max]="maxDate"/>
                    <mat-datepicker-toggle style="font-size: 36px;" matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker> -->
                      </mat-form-field>

                      <mat-error
                        *ngIf="form.get('private_date_of_birth').errors && (submitted || form.get('private_date_of_birth').touched)">
                        {{messages.birthdayInvalid}}
                      </mat-error>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editPersonal">
                      {{ user.private_date_of_birth }}
                    </div>
                  </div>
                </div>

                <!-- SOCIAL -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [(edit)]="editSocial" [baseDataObject]="user"
                    privacyUserAttributeName="private_social_information_privacy" [title]="'Netzwerk Informationen'"
                    [atts]="['private_telephone', 'email', 'private_website', 'private_facebook']"
                    [save]="save.bind(this)" [savedisabled]="form.invalid"
                    [editdisabled]="editNames||editPersonal||editAddress||editCareer||editAboutme"
                    [cancel]="cancel.bind(this)" [tooltip]="messages.texts.profile.blockheader.infotexts.social"
                    [form]="form" [(submitted)]="submitted">
                  </app-about-block-header>

                  <!-- telephone -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Telefon:</div>

                    <!-- edit -->
                    <div *ngIf="editSocial" fxFlex="grow" fxLayout="column">
                      <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" type="tel" matInput formControlName="private_telephone" />
                      </mat-form-field>

                      <mat-error
                        *ngIf="form.get('private_telephone').errors && (submitted || form.get('private_telephone').touched)">
                        {{messages.telInvalid}}
                      </mat-error>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editSocial">
                      {{ user.private_telephone }}
                    </div>
                  </div>

                  <!-- email -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">E-Mail:</div>

                    <!-- edit -->
                    <div *ngIf="editSocial" fxLayout="column" fxLayoutGap="5px">

                      <div>{{user.email}}</div>

                      <button (click)="changeMailButtonClicked()">Email Adresse ändern</button>

                    </div>

                    <!-- show -->
                    <div *ngIf="!editSocial" style="word-break: break-word;">
                      {{ user.email }}
                    </div>
                  </div>

                  <!-- website -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Website:</div>

                    <!-- edit -->
                    <div *ngIf="editSocial" fxFlex="grow" fxLayout="column">
                      <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" type="text" matInput formControlName="private_website" />
                      </mat-form-field>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editSocial">
                      <a [href]="user.private_website" target="_blank" style="word-break: break-word;">{{
                        user.private_website }}</a>
                    </div>
                  </div>

                  <!-- facebook -->
                  <div fxLayout="row" fxLayout.lt-lg="column">

                    <!-- label -->
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Facebook:</div>

                    <!-- edit -->
                    <div *ngIf="editSocial" fxFlex="grow" fxLayout="column">
                      <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" type="text" matInput formControlName="private_facebook" />
                      </mat-form-field>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editSocial">
                      <a [href]="user.private_facebook" target="_blank" style="word-break: break-word;">{{
                        user.private_facebook }}</a>
                    </div>
                  </div>
                </div>

                <!-- ADDRESS -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [(edit)]="editAddress" [baseDataObject]="user"
                    [privacyUserAttributeName]="'private_address_privacy'" [title]="'Adresse'"
                    [atts]="['private_street', 'private_street_additional', 'private_zip', 'private_city', 'private_country', 'private_state']"
                    [save]="save.bind(this)" [savedisabled]="form.invalid"
                    [editdisabled]="editNames||editPersonal||editSocial||editCareer||editAboutme"
                    [cancel]="cancel.bind(this)" [tooltip]="messages.texts.profile.blockheader.infotexts.address"
                    [form]="form" [(submitted)]="submitted">
                  </app-about-block-header>

                  <!-- street -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Straße:</div>

                    <div class="full-width-input" *ngIf="editAddress">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_street" />
                      </mat-form-field>
                    </div>

                    <div *ngIf="!editAddress">
                      {{ user.private_street }}
                    </div>
                  </div>

                  <!-- private_street_additional -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Hausnummer:</div>

                    <div class="full-width-input" *ngIf="editAddress">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_street_additional" />
                      </mat-form-field>
                    </div>

                    <div *ngIf="!editAddress">
                      {{ user.private_street_additional }}
                    </div>
                  </div>

                  <!-- private_zip -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">PLZ:</div>

                    <div class="full-width-input" *ngIf="editAddress">

                      <!-- old @angular-material-extensions/google-maps-autocomplete autocomplete -->
                      <!-- <mat-form-field>
                    <input matInput
                    formControlName="private_zip"
                    matGoogleMapsAutocomplete
                    type="text"
                    [types]="['geocode']"
                    [country]="['de','at','ch']"
                    (onAutocompleteSelected)="onAutocompleteSelected($event)"
                    (onLocationSelected)="onLocationSelected($event)">
                  </mat-form-field> -->

                      <!-- FIELDs WITHOUT GOOGLE COMPLETION -->
                      <mat-form-field>
                        <input matInput type="text" formControlName="private_zip" placeholder="PLZ" />
                      </mat-form-field>
                    </div>

                    <div *ngIf="!editAddress">
                      {{ user.private_zip }}
                    </div>
                  </div>

                  <!-- private_city -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Ort:</div>

                    <div class="full-width-input" *ngIf="editAddress">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_city" />
                      </mat-form-field>
                    </div>

                    <div *ngIf="!editAddress">
                      {{ user.private_city }}
                    </div>
                  </div>

                  <!-- state -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Bundesland:</div>
                    <div class="full-width-input" *ngIf="editAddress">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_state">
                      </mat-form-field>
                    </div>

                    <div *ngIf="!editAddress">
                      {{ user.private_state }}
                    </div>
                  </div>

                  <!-- country -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Land:</div>
                    <div *ngIf="editAddress">
                      <mat-form-field>
                        <mat-select formControlName="private_country">
                          <mat-option *ngFor="let c of countries" [value]="c">{{c}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div *ngIf="!editAddress">
                      {{ user.private_country }}
                    </div>
                  </div>
                </div>

                <!-- CAREER -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [(edit)]="editCareer" [baseDataObject]="user"
                    [privacyUserAttributeName]="'private_career_privacy'" [title]="'Beruflicher Werdegang'"
                    [atts]="['private_job','private_job_position','private_school','private_employer','private_former_employers']"
                    [save]="save.bind(this)" [savedisabled]="form.invalid"
                    [editdisabled]="editNames||editPersonal||editSocial||editAddress||editAboutme"
                    [cancel]="cancel.bind(this)" [tooltip]="messages.texts.profile.blockheader.infotexts.career"
                    [form]="form" [(submitted)]="submitted">
                  </app-about-block-header>

                  <!-- job -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Beruf:</div>
                    <div class="full-width-input" *ngIf="editCareer">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_job" />
                      </mat-form-field>
                    </div>
                    <div *ngIf="!editCareer">
                      {{ user.private_job }}
                    </div>
                  </div>

                  <!-- position -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Position:</div>
                    <div class="full-width-input" *ngIf="editCareer">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_job_position" />
                      </mat-form-field>
                    </div>
                    <div *ngIf="!editCareer">
                      {{ user.private_job_position }}
                    </div>
                  </div>

                  <!-- school -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Schule:</div>
                    <div class="full-width-input" *ngIf="editCareer">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_school" />
                      </mat-form-field>
                    </div>
                    <div *ngIf="!editCareer">
                      {{ user.private_school }}
                    </div>
                  </div>

                  <!-- employer -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Arbeitgeber:</div>
                    <div class="full-width-input" *ngIf="editCareer">
                      <mat-form-field>
                        <input type="text" matInput formControlName="private_employer" />
                      </mat-form-field>
                    </div>
                    <div *ngIf="!editCareer">
                      {{ user.private_employer }}
                    </div>
                  </div>

                  <!-- former employers -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div fxFlex="15" fxFlex.xs="grow" class="label">Frühere Arbeitgeber:</div>

                    <!-- edit -->
                    <div class="full-width-input" *ngIf="editCareer">
                      <mat-form-field style="width: 100%;">
                        <textarea
                          style="width: 100%; min-height: 100px; padding: 10px 10px; text-indent: 0px; box-sizing: border-box;"
                          class="zimTextarea" matInput formControlName="private_former_employers" autoresize></textarea>
                      </mat-form-field>

                      <mat-error
                        *ngIf="form.get('private_former_employers').errors && (submitted || form.get('private_former_employers').touched)">
                        *Es dürfen maximal 255 Zeichen eingegeben werden.
                      </mat-error>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editCareer" style="white-space: pre-line; word-break: break-word;">
                      {{ user.private_former_employers }}
                    </div>
                  </div>
                </div>

                <!-- ABOUTME -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [(edit)]="editAboutme" [baseDataObject]="user"
                    [privacyUserAttributeName]="'private_about_me'" [title]="'Über meinen Werdegang'"
                    [atts]="['private_self_description']" [save]="save.bind(this)" [savedisabled]="form.invalid"
                    [editdisabled]="editNames||editPersonal||editSocial||editAddress||editCareer"
                    [cancel]="cancel.bind(this)" [tooltip]="messages.texts.profile.blockheader.infotexts.aboutme"
                    [form]="form" [(submitted)]="submitted">
                  </app-about-block-header>

                  <!-- edit -->
                  <div fxLayout="row" fxLayout.lt-lg="column">
                    <div class="full-width-input" *ngIf="editAboutme">
                      <mat-form-field style="width: 100%;">
                        <textarea
                          style="width: 100%; min-height: 100px; padding: 10px 10px;text-indent: 0px; box-sizing: border-box;"
                          class="zimTextarea" matInput formControlName="private_self_description" autoresize></textarea>
                      </mat-form-field>
                    </div>

                    <!-- show -->
                    <div *ngIf="!editAboutme" style="white-space: pre-line;">
                      {{ user.private_self_description }}
                    </div>
                  </div>
                </div>

                <!-- CERTIFICATE -->
                <div class="infoblock" fxLayout="column" fxLayoutGap="10px">
                  <app-about-block-header [title]="'Zertifikat'"
                    [tooltip]="messages.texts.profile.blockheader.infotexts.certificates">
                  </app-about-block-header>

                  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutAlign="start start" fxLayoutGap="20px">

                    <edit-images *ngIf="user.certificateImage" [images]="[user.certificateImage]"
                      [deleteImage]="deleteCertificateImage.bind(this)" [key]="'PROFILE_CERTIFICATE'"></edit-images>

                    <image-upload-box *ngIf="!user.certificateImage" [fileSelected]="fileSelected.bind(this)"
                      [fileDropped]="fileDropped.bind(this)" [key]="'PROFILE_CERTIFICATE'" [multiple]="false">
                    </image-upload-box>

                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <app-footer></app-footer>

</zimmerer-route-ion-wrapper>